import { render } from "./ReferencePage.vue?vue&type=template&id=b6cb163e&scoped=true"
const script = {}

import "./ReferencePage.vue?vue&type=style&index=0&id=b6cb163e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cb163e"]])

export default __exports__